export const getDataFromClusterName = (name?: string) => {
  let code, title;
  if (name) {
    [code, title] = name ? name.split('|').map((s) => s.trim()) : [];
  }
  if (!title) [code, title] = ['', code]
  return [code, title];
}